import toast from "react-hot-toast";
import { apiEndPoints } from "../../ApiServices/config";
import { postApi } from "../../ApiServices/api";

function useCacellation(reset,params){
    const onSubmit = async (data) => {
        try {
          const response = await postApi(
            `${apiEndPoints.sendRejectionMail}/${params.bookingId}`,
            { reason: data.reason }
          );
          if (response?.data?.status === 0) {
            toast.error(response?.data?.message);
          } else {
            toast.success(response?.data?.message);
            reset();
          }
        } catch (error) {
          toast.error(`Cancellation Request failed: ${error}`);
        }
      };

      return {
        onSubmit
      };
}

export default useCacellation;